<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="closeModal()" />
</div>

<ion-content>
  <div *ngIf="!showConfirmation" style="border: 0px">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-title class="smaller">
            <!-- Forbruksoversikt -->
            <h1>Forbruks&#173;oversikt</h1>
          </ion-title>
        </ion-col>
      </ion-row>
      <ion-row class="m-b">
        <ion-col size="10" offset="1">
          <div *ngIf="_showAnleggsliste === true">
            <ion-select
              [(ngModel)]="valgtAnlegg"
              (ngModelChange)="anleggChanged()"
              interface="popover"
              justify="space-between"
              labelPlacement="stacked"
              #adrSelect
              [interfaceOptions]="{
                header: 'Velg anlegg',
              }"
            >
              <ion-select-option *ngFor="let adr of anleggList" [value]="adr">
                <span *ngIf="anleggIsInactive(adr)">[Avsluttet]</span>
                {{adr.adresse}} &nbsp;<ion-icon
                  name="caret-down-outline"
                ></ion-icon>
              </ion-select-option>
            </ion-select>
          </div>

          <div class="leadaddress" *ngIf="(_showAnleggsliste === false)">
            {{valgtAnlegg.adresse}}
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="m-b" size="10" offset="1">
          <div
            class="backorforth"
            style="
              width: 250px;
              align-content: center;
              display: inline-block;
              margin-left: auto;
              margin-right: auto;
            "
          >
            <div id="bf_maaned">
              <table width="100%">
                <tr>
                  <td width="100%">
                    <span>
                      <ion-icon name="calendar"></ion-icon
                      >&nbsp;{{this.selectedDate | date:'MMMM yyyy':'':'nb' |
                      titlecase}}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="m-b" style="padding-top: 0px" size="10" offset="1">
          <div
            style="
              width: 250px;
              align-content: center;
              display: inline-block;
              margin-left: auto;
              margin-right: auto;
            "
          >
            <div
              style="
                align-content: center;
                display: inline-block;
                margin-left: auto;
                margin-right: auto;
              "
            >
              <div class="datepicker-here" id="airDownload0"></div>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="m-b" size="10" offset="1">
          <div
            style="
              width: 250px;
              align-content: center;
              display: inline-block;
              margin-left: auto;
              margin-right: auto;
            "
          >
            Excelfil med forbruk og kostnader vil bli sendt til
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="m-b" size="10" offset="1">
          <div class="form-input-ihk">
            <ion-input
              label="E-post"
              labelPlacement="stacked"
              fill="outline"
              [(ngModel)]="epost"
              type="email"
            ></ion-input>
          </div>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="valgtAnlegg !== undefined">
        <ion-col class="m-b" size="10" offset="1">
          <div
            style="
              width: 250px;
              align-content: center;
              display: inline-block;
              margin-left: auto;
              margin-right: auto;
            "
          >
            <ion-button
              [disabled]="hasClickedExport"
              strong="true"
              class="dark wide"
              (click)="sendExcel()"
              ><ion-icon slot="start" name="download-outline"></ion-icon
              ><b>Eksporter til excel</b></ion-button
            >
          </div>
        </ion-col>
      </ion-row>

      <ion-row class="m-b">
        <ion-col size="10" offset="1">
          <div class="leadaddress abort" (click)="closeModal()">Avbryt</div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <div *ngIf="showConfirmation">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-title class="smaller"> Bekreftelse </ion-title>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="m-b">
          <div>Epost sendt til {{epost}}</div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="m-b" style="margin-top: 6vh">
          <div>
            <img src="/assets/img/shared/success.svg" />
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
